
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiBeaconGeneralConeDown as ObiBeaconGeneralConeDownElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-beacon-general-cone-down.js';
 
 
 

 
 export const ObiBeaconGeneralConeDown = createComponent({
   react: React,
   tagName: 'obi-beacon-general-cone-down',
   elementClass: ObiBeaconGeneralConeDownElement,
   events: {
     
   }
  });
 
 